import styles from "./ADSProductSelector.module.scss";
import { useADSContext } from "../../../../../../context/ADSProvider";
import ADSProductSelectorMain from "./Component/ADSProductSelectorMain";

const ADSProductSelector = () => {
  const { productFilter, setProductFilter } = useADSContext();

  const handleChangeFavorite = ({ favorite }) => {
    if (favorite !== productFilter.favorite) {
      setProductFilter({
        favorite,
        page: 0,
        size: 20,
      });
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.textWrapper}>
        <span
          className={!productFilter.favorite ? styles.active : ""}
          onClick={() => handleChangeFavorite({ favorite: false })}
        >
          ALL
        </span>

        {/* LINE separator */}
        <span style={{ width: 2, height: 16, backgroundColor: "#FB4764" }} />

        <span
          className={productFilter.favorite ? styles.active : ""}
          onClick={() => handleChangeFavorite({ favorite: true })}
        >
          FAVORITES
        </span>
      </div>

      <ADSProductSelectorMain />
    </div>
  );
};

export default ADSProductSelector;
